module.exports = __webpack_public_path__ + "img/alert.2f00830c.svg";